import React from "react";
import moment from "moment";
import "moment/locale/es";
import {
  Badge,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import * as Icon from "react-feather";
import { useNotifications } from "../../../context/notifications";
import { getNotificationPresentation } from "../../../context/notifications.helpers";

moment.locale("es");

const notificationIconMap = {
  bell: Icon.Bell,
  clipboard: Icon.Clipboard,
  "check-circle": Icon.CheckCircle,
  "alert-circle": Icon.AlertCircle,
  "alert-triangle": Icon.AlertTriangle,
};

const formatRelativeDate = (value) => {
  const date = moment(value);
  return date.isValid() ? date.fromNow() : "";
};

const NavbarNotifications = () => {
  const {
    notifications,
    unreadCount,
    isConnected,
    markAllAsRead,
    openNotification,
  } = useNotifications();

  const visibleNotifications = notifications.slice(0, 6);
  const pendingLabel =
    unreadCount === 0
      ? "Todo al día"
      : unreadCount === 1
        ? "1 pendiente"
        : `${unreadCount} pendientes`;
  const connectionLabel = isConnected
    ? "Avisos activos"
    : "Actualización pausada";

  return (
    <UncontrolledDropdown tag="li" className="dropdown-notification nav-item">
      <DropdownToggle
        tag="button"
        type="button"
        className="nav-link nav-link-label position-relative border-0 bg-transparent"
        aria-label="Abrir notificaciones"
      >
        <Icon.Bell size={20} />
        {unreadCount > 0 ? (
          <Badge color="danger" pill className="badge-up">
            {unreadCount > 9 ? "9+" : unreadCount}
          </Badge>
        ) : null}
      </DropdownToggle>

      <DropdownMenu
        right
        className="dropdown-menu-media mt-0 crm-notifications-menu"
      >
        <div className="crm-notifications-menu__header">
          <div>
            <span className="crm-notifications-menu__eyebrow">
              {pendingLabel}
            </span>
            <h5 className="crm-notifications-menu__title">Notificaciones</h5>
          </div>
          <span
            className={`crm-notifications-menu__status ${
              isConnected ? "is-live" : "is-paused"
            }`}
          >
            {connectionLabel}
          </span>
        </div>

        <div className="crm-notifications-menu__list">
          {visibleNotifications.length ? (
            visibleNotifications.map((notification) => {
              const presentation = getNotificationPresentation(notification);
              const Glyph =
                notificationIconMap[presentation.iconName] ||
                notificationIconMap.bell;

              return (
                <button
                  key={notification.id}
                  type="button"
                  className={`crm-notification-item ${
                    notification.read ? "" : "is-unread"
                  }`}
                  style={{
                    "--notification-accent": presentation.accentColor,
                    "--notification-soft": presentation.softColor,
                  }}
                  onClick={() => openNotification(notification)}
                >
                  <span className="crm-notification-item__icon">
                    <Glyph size={18} />
                  </span>

                  <span className="crm-notification-item__body">
                    <span className="crm-notification-item__top">
                      <span className="crm-notification-item__badge">
                        {presentation.badgeLabel}
                      </span>
                      <span className="crm-notification-item__time">
                        {formatRelativeDate(notification.createdAt)}
                      </span>
                    </span>

                    <span className="crm-notification-item__title">
                      {presentation.title}
                    </span>

                    {presentation.message ? (
                      <span className="crm-notification-item__message">
                        {presentation.message}
                      </span>
                    ) : null}

                    {presentation.metaLine ? (
                      <span className="crm-notification-item__meta">
                        {presentation.metaLine}
                      </span>
                    ) : null}

                    <span className="crm-notification-item__helper">
                      {presentation.helperText || presentation.actionLabel}
                    </span>
                  </span>

                  {!notification.read ? (
                    <span className="crm-notification-item__dot" />
                  ) : null}
                </button>
              );
            })
          ) : (
            <div className="crm-notifications-empty">
              <div className="crm-notifications-empty__icon">
                <Icon.Inbox size={20} />
              </div>
              <span className="crm-notifications-empty__title">
                No tienes avisos nuevos
              </span>
              <span className="crm-notifications-empty__text">
                Cuando te asignen un ticket o haya una novedad importante,
                aparecerá aquí.
              </span>
            </div>
          )}
        </div>

        <div className="crm-notifications-menu__footer">
          <button
            type="button"
            className="crm-notifications-menu__footer-button"
            onClick={markAllAsRead}
            disabled={!unreadCount}
          >
            Marcar todo como visto
          </button>
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default NavbarNotifications;
